import { render, staticRenderFns } from "./DurationInput.vue?vue&type=template&id=4b8528e7&scoped=true"
import script from "./DurationInput.vue?vue&type=script&lang=js"
export * from "./DurationInput.vue?vue&type=script&lang=js"
import style0 from "./DurationInput.vue?vue&type=style&index=0&id=4b8528e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8528e7",
  null
  
)

export default component.exports